Object.defineProperty(exports, '__esModule', { value: true });
const prefix = 'fasr';
const iconName = 'ellipsis';
const width = 448;
const height = 512;
const aliases = ['ellipsis-h'];
const unicode = 'f141';
const svgPathData = 'M24 296l0-80 80 0 0 80-80 0zm160 0l0-80 80 0 0 80-80 0zm160-80l80 0 0 80-80 0 0-80z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
